import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "scp__panel",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "비밀번호 확인"
}
const _hoisted_2 = { class: "scp__head" }
const _hoisted_3 = { class: "scp__lead" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "scp__error",
  role: "alert"
}
const _hoisted_6 = { class: "scp__foot" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

import { nextTick, ref, watch } from 'vue'
import AppIcon from '@/components/common/AppIcon.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContractPasswordModal',
  props: {
    open: { type: Boolean },
    reason: {},
    busy: { type: Boolean },
    error: {}
  },
  emits: ["close", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const password = ref('')
const inputEl = ref<HTMLInputElement | null>(null)

watch(
  () => props.open,
  (open) => {
    if (!open) {
      password.value = ''
      return
    }
    nextTick(() => inputEl.value?.focus())
  },
)

function onSubmit() {
  if (props.busy || !password.value.trim()) return
  emit('confirm', password.value.trim())
}

return (_ctx: any,_cache: any) => {
  return (__props.open)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "scp",
        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (emit('close')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("header", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("h2", { class: "scp__title" }, "비밀번호 확인", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "scp__x",
              "aria-label": "비밀번호 창 닫기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-close",
                size: 20
              })
            ])
          ]),
          _createElementVNode("form", {
            class: "scp__body",
            onSubmit: _withModifiers(onSubmit, ["prevent"])
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(__props.reason) + " 직원만 할 수 있는 동작입니다. 비밀번호를 입력해 주세요. ", 1),
            _cache[5] || (_cache[5] = _createElementVNode("label", {
              class: "scp__label",
              for: "scp-password"
            }, "비밀번호", -1)),
            _withDirectives(_createElementVNode("input", {
              id: "scp-password",
              ref_key: "inputEl",
              ref: inputEl,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
              class: "scp__input",
              type: "password",
              inputmode: "numeric",
              autocomplete: "current-password",
              disabled: __props.busy
            }, null, 8, _hoisted_4), [
              [_vModelText, password.value]
            ]),
            (__props.error)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.error), 1))
              : _createCommentVNode("", true),
            _createElementVNode("footer", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "scp__btn scp__btn--ghost",
                disabled: __props.busy,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
              }, " 닫기 ", 8, _hoisted_7),
              _createElementVNode("button", {
                type: "submit",
                class: "scp__btn scp__btn--teal",
                disabled: __props.busy || !password.value.trim()
              }, _toDisplayString(__props.busy ? '확인 중…' : '확인'), 9, _hoisted_8)
            ])
          ], 32)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})